import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  FormHelperText,
  LinearProgress
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import _ from 'lodash';
import classNames from 'classnames';

import './PersonalData.scss';
import Icon from '../../Icon/Icon';
import Button from '../../Button/Button';

class PersonalData extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
      accountId: '',
      firstName: '',
      lastName: '',
      username: '',
      birthdate: '',
      idNumber: '',
      email: '',
      telephoneNumber: '',
      receiveNewsLetter: false,
      promotions: false,
      address: '',
      postalCode: '',
      city: '',
      country: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      owner: '',
      accountNumber: '',
      bankName: '',
      iban: '',
      bicswift: '',
      showPassword: false,
      errors: {
        newPassword: '',
        confirmPassword: '',
        birthdate: '',
        telephoneNumber: ''
      },
      save: false
    };
    this.currentPassword = React.createRef();
  }

  componentDidMount() {
    if (this.props.customer !== undefined) {
      const customer = this.props.customer;

      this.setState({
        selected: 0,
        accountId: customer.accountNumber || '',
        firstName: customer.firstName,
        lastName: customer.lastName,
        username: customer.username,
        birthdate: customer.birthdate,
        idNumber: customer.personalIdNumber,
        email: customer.email,
        telephoneNumber: customer.cellphone,
        receiveNewsLetter: customer.subscribedToNewsletter || false,
        promotions: customer.subscribedToNewProducts || false,
        address: customer.address ? customer.address.addressLine1 : '',
        postalCode: customer.address ? customer.address.postCode : '',
        city: customer.address ? customer.address.city : '',
        country: customer.address ? customer.address.country : '',
        currentPassword: '',
        owner: customer.paymentAccount ? customer.paymentAccount.ownerName : '',
        accountNumber: customer.paymentAccount ? customer.paymentAccount.accountNumber : '',
        bankName: customer.paymentAccount ? customer.paymentAccount.bankName : '',
        iban: customer.paymentAccount ? customer.paymentAccount.iban : '',
        bicswift: customer.paymentAccount ? customer.paymentAccount.swift : ''
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.customer !== prevProps.customer) {
      const customer = this.props.customer;

      this.setState({
        accountId: customer.accountNumber,
        firstName: customer.firstName,
        lastName: customer.lastName,
        username: customer.username,
        birthdate: customer.birthdate,
        idNumber: customer.personalIdNumber,
        email: customer.email,
        telephoneNumber: customer.cellphone,
        receiveNewsLetter: customer.subscribedToNewsletter,
        promotions: customer.subscribedToNewProducts,
        address: customer.address.addressLine1,
        postalCode: customer.address.postCode,
        city: customer.address.city,
        country: customer.address.country,
        owner: customer.paymentAccount && customer.paymentAccount.ownerName,
        accountNumber: customer.paymentAccount ? customer.paymentAccount.accountNumber : '',
        bankName: customer.paymentAccount && customer.paymentAccount.bankName,
        iban: customer.paymentAccount && customer.paymentAccount.iban,
        bicswift: customer.paymentAccount && customer.paymentAccount.swift
      });

    }
  }

  setErrorMessage(name, value) {
    const { t, passwordStrength, passwordValidation } = this.props;
    let message = '';

    if (name === 'confirmPassword') {
      if (value !== this.state.newPassword) {
        message = t('form.fieldsDontMatch');
      }
    } else if (name === 'newPassword') {
      if (passwordValidation && passwordValidation.strength < passwordStrength.minStrength) {
        message = t('form.blankTooWeak');
      }

      if (value.length < passwordStrength.min) {
        message = t('form.blankTooShort');
      }

      if (value.length > passwordStrength.max) {
        message = t('form.blankTooLong');
      }
    }

    return message;
  }


  validateForm = () => {
    let messageBirthdate = '';
    let messageTelephone = '';

    if (Math.floor((new Date() - new Date(this.state.birthdate).getTime()) / 3.15576e+10) < 18) {
      messageBirthdate = 'You need to be over 18.';
      this.setState({ save: false });
    } else if (!(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(this.state.birthdate)))  {
      messageBirthdate = 'Date format must be valid';
      this.setState({ save: false });
    } else {
      this.setState({ save: true });
    }

    if (this.state.telephoneNumber.toString().length < 9) {
      messageTelephone = 'Must have at least 9 numbers';
      this.setState({ save: false });
    } else {
      this.setState({ save: true });
    }

    const message = {
      messageBirthdate: messageBirthdate,
      messageTelephone: messageTelephone
    };

    return message;
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      birthdate: this.state.birthdate,
      idNumber: this.state.idNumber,
      telephoneNumber: this.state.telephoneNumber,
      receiveNewsLetter: this.state.receiveNewsLetter,
      promotions: this.state.promotions,
      address: this.state.address,
      postalCode: this.state.postalCode,
      city: this.state.city,
      country: this.state.country,
      currentPassword: this.state.currentPassword,
      newPassword: this.state.newPassword,
      confirmPassword: this.state.confirmPassword,
      bicswift: this.state.bicswift
    };

    if (!this.props.success) {
      this.currentPassword.current.focus();
    }

    this.currentPassword.current.value = '';
    this.props.saveCustomer(payload);
  }

  onChangeValue = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    }, () => {
      const valid = this.validateForm();

      if (valid.messageBirthdate === '' && valid.messageTelephone === '') {
        this.validatePasswordStrength(name, value);
        this.setState({ save: true });
      } else {
        this.setState({ errors: { ...this.state.errors, birthdate: valid.messageBirthdate, telephoneNumber: valid.messageTelephone }, save: false });
      }
    });
  }

  onChangeValueCheckBox = (e) => {
    this.setState({
      [e.target.name]: !this.state[e.target.name],
      save: true
    });
  }

  onChangeValueDate = (name) => (value) => {
    this.setState({ [name]: format(value, 'yyyy-MM-dd') },
      () => {
        const valid = this.validateForm();

        if (valid.messageBirthdate === '' && valid.messageTelephone === '') {
          this.validatePasswordStrength(name, value);
          this.setState({ save: false });
        } else {
          this.setState({ errors: { ...this.state.errors, birthdate: valid.messageBirthdate, telephoneNumber: valid.messageTelephone } });
        }
      });
  }

  validatePasswordStrength = _.debounce(async (name, value) => {
    if (name === 'newPassword') {
      await this.props.validatePassword(value);
    }

    this.setState({ errors: { ...this.state.errors, [name]: value !== '' ? this.setErrorMessage(name, value) : '' } });
  }, 500, { maxWait: 1000 })

  render() {
    const {
      t,
      passwordValidation: { strength, tips },
      passwordStrength: { minLength, maxLength, minStrength }
    } = this.props;
    const {
      accountId,
      firstName,
      lastName,
      birthdate,
      idNumber,
      email,
      username,
      telephoneNumber,
      address,
      postalCode,
      city,
      country,
      currentPassword,
      showPassword,
      newPassword,
      confirmPassword,
      errors,
      promotions,
      receiveNewsLetter,
      save
    } = this.state;
    const strengthLevel = minStrength > strength ? 0 : (strength * 20) || 0;
    const name = `${ firstName } ${ lastName }`;
    const passwordValidationClauses = {
      uppercase_letters: { msg: t('form.uppercase_letters'), valid: false },
      lowercase_letters: { msg: t('form.lowercase_letters'), valid: false },
      numbers: { msg: t('form.numbers'), valid: false },
      special_chars: { msg: t('form.special_chars'), valid: false },
      long: { msg: t('form.long'), valid: false }
    };

    for (const clause of Object.keys(passwordValidationClauses)) {
      passwordValidationClauses[clause].valid = tips.indexOf(clause) === -1;
    }

    let passwordStrengthLabel = 'Very Weak';
    let passwordStrengthClass = 'red';
    if (strengthLevel >= 100) {
      passwordStrengthLabel = 'Very Strong';
      passwordStrengthClass = 'green';
    } else if (strengthLevel >= 80) {
      passwordStrengthLabel = 'Strong';
      passwordStrengthClass = 'green';
    } else if (strengthLevel >= 60) {
      passwordStrengthLabel = 'Good';
      passwordStrengthClass = 'yellow';
    } else if (strengthLevel >= 40) {
      passwordStrengthLabel = 'Weak';
    }

    return (
      <form ref={ el => this.formRef = el } className="form" onSubmit={ this.handleSubmit }>

        <div className="form__sub-container">
          <div className="form__title">{ t('accountPersonalData.myProfile') }</div>
          <div className="form__inputs">

            <div className="form__side-container">
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.accountId') }: </label>
                <input
                  defaultValue={ accountId }
                  type="text"
                  disabled
                  className={
                    classNames({
                      'form__label-input-container__elem': true,
                      'form__label-input-container__elem--disabled' :true,
                      'form__label-input-container__elem form__label-input-container__elem--fullWidth': true
                    })
                  }
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.name') }:</label>
                <input
                  value={ name }
                  onChange={ this.onChangeValue }
                  className={
                    classNames({
                      'form__label-input-container__elem': true,
                      'form__label-input-container__elem form__label-input-container__elem--fullWidth': true
                    })
                  }
                  type="text"
                  name="firstName"
                  disabled
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.birthdate') }:</label>
                <DatePicker
                  disableFuture
                  openTo="year"
                  format="yyyy-MM-dd"
                  views={ ['year', 'month', 'date'] }
                  name="birthdate"
                  className="form__label-input-container__elem form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  value={ birthdate }
                  onChange={ this.onChangeValueDate('birthdate') }
                  inputVariant="outlined"
                  TextFieldComponent={ TextField }
                  InputLabelProps={ { shrink: false } }
                  error={ !!errors['birthdate'] }
                  helperText={ errors['birthdate'] }
                  required={ true }
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.idNumber') }:</label>
                <input
                  defaultValue={ idNumber }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  type="text"
                  name="idNumber"
                />
              </div>
              <div className="form__label-input-container form__label-input-container">
                <label>{ t('accountPersonalData.email') }:</label>
                <input
                  defaultValue={ email }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  type="email"
                  name="email"
                  disabled
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.telephone') }:</label>
                <input
                  defaultValue={ email }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem
                   form__label-input-container__elem--fullWidth"
                  type="text"
                  value={ telephoneNumber }
                  name="telephoneNumber"
                  disabled
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.username') }: </label>
                <input
                  defaultValue={ username }
                  type="text"
                  disabled
                  className={
                    classNames({
                      'form__label-input-container__elem': true,
                      'form__label-input-container__elem--large': true,
                      'form__label-input-container__elem--disabled' :true
                    })
                  }
                />
              </div>
            </div>
            <div className="form__side-container">
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.address') }:</label>
                <input
                  defaultValue={ address }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  type="text"
                  name="address"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.postalCode') }:</label>
                <input
                  defaultValue={ postalCode }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem
                  form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  type="text"
                  name="postalCode"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.city') }:</label>
                <input
                  defaultValue={ city }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem
                  form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  type="text"
                  name="city"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.country') }:</label>
                <select
                  className="form__label-input-container__elem form__label-input-container__elem--fullWidth"
                  name="country"
                  value={ country }
                  onChange={ this.onChangeValue }
                >
                  {
                    _.map(this.props.countries, (country, index) => <option key={ index } value={ country.value }>{ country.text }</option>)
                  }
                </select>
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.currentPassword') }:</label>
                <input
                  ref={ this.currentPassword }
                  required
                  defaultValue={ currentPassword }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem
                  form__label-input-container__elem--fullWidth"
                  type="password"
                  name="currentPassword"
                  autoComplete="new-password"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.newPassword') }:</label>
                <TextField
                  type={ showPassword ? 'text' : 'password' }
                  name="newPassword"
                  className="form__label-input-container__elem form__label-input-container__elem--text-field
                  form__label-input-container__elem--fullWidth"
                  value={ newPassword }
                  onChange={ this.onChangeValue }
                  variant="outlined"
                  error={ !!errors.newPassword }
                  autoComplete="off"
                  InputLabelProps={ { shrink: false } }
                  InputProps={
                    {
                      endAdornment: (
                        <InputAdornment position="end" className="form__label-input-container__eye-icon">
                          {
                            <Icon
                              icon={ showPassword ? 'eyeOpen' : 'eyeClosed' }
                              className="form-container__eye-icon"
                              onClick={ () => this.setState({ showPassword: !showPassword }) }
                            />
                          }
                        </InputAdornment>
                      )
                    }
                  }
                />
                {
                  newPassword !== '' && (
                    <FormHelperText
                      component="div"
                      className={ `form-container__form-strength form-container__form-strength--${ passwordStrengthClass }` }
                    >
                      <span className="form-container__form-strength--label">{ passwordStrengthLabel }</span>
                      <LinearProgress variant="determinate" value={ strengthLevel } />
                    </FormHelperText>
                  )
                }
                {
                  newPassword !== '' && (
                    <FormHelperText component="div" className="form-container__password-hints">
                      {
                        minStrength < 5 && (
                          <h5>
                            {
                              t('form.passwordPolicyTitle')
                                .replace('%min', minLength)
                                .replace('%max', maxLength)
                                .replace('%strength', minStrength)
                            }
                          </h5>
                        )
                      }
                      {
                        minStrength === 5 && (
                          <h5>{ t('form.passwordPolicyTitleStrict') }</h5>
                        )
                      }
                      {
                        _.map(Object.keys(passwordValidationClauses), (tip, index) => (
                          <p
                            key={ index }
                            className={
                              classNames({
                                'form-container____password-hints': true,
                                'valid': passwordValidationClauses[tip].valid,
                                'not-valid': !passwordValidationClauses[tip].valid
                              })
                            }
                          >
                            { passwordValidationClauses[tip].msg }
                          </p>
                        ))
                      }
                    </FormHelperText>
                  )
                }
              </div>
              <div className={
                classNames({
                  'form__label-input-container': true,
                  'form__label-input-container--error': newPassword !== ''
                })
              }
              >
                <label>{ t('accountPersonalData.retypePassword') }:</label>
                <TextField
                  type={ showPassword ? 'text' : 'password' }
                  name="confirmPassword"
                  className="form__label-input-container__elem form__label-input-container__elem--text-field
                   form__label-input-container__elem--fullWidth"
                  value={ confirmPassword }
                  onChange={ this.onChangeValue }
                  variant="outlined"
                  error={ !!errors.confirmPassword }
                  helperText={ errors.confirmPassword }
                  autoComplete="off"
                  InputLabelProps={ { shrink: false } }
                  InputProps={
                    {
                      endAdornment: (
                        <InputAdornment position="end" className="form__label-input-container__eye-icon">
                          {
                            <Icon
                              icon={ showPassword ? 'eyeOpen' : 'eyeClosed' }
                              className="form-container__eye-icon"
                              onClick={ () => this.setState({ showPassword: !showPassword }) }
                            />
                          }
                        </InputAdornment>
                      )
                    }
                  }
                />
              </div>
            </div>
          </div>
          <div className="form__side-container">
            <span>{ t('accountPersonalData.info') }</span>
          </div>
          <div className="form__side-container">
            <FormControlLabel
              control={
                <Checkbox
                  name="receiveNewsLetter"
                  checked={ receiveNewsLetter }
                  icon={ <Icon icon="radioButtonOpen" /> }
                  checkedIcon={ <Icon icon="radioButton" /> }
                  onChange={ this.onChangeValueCheckBox }
                  required={ false }
                  color="primary"
                  fontSize="small"
                />
              }
              label={ <span className="form__small--title">{ t('accountPersonalData.receiveNewsletter') }</span> }
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="promotions"
                  checked={ promotions }
                  icon={ <Icon icon="radioButtonOpen" /> }
                  checkedIcon={ <Icon icon="radioButton" /> }
                  onChange={ this.onChangeValueCheckBox }
                  required={ false }
                  color="primary"
                  fontSize="small"
                />
              }
              label={ <span className="form__small--title">{ t('accountPersonalData.receivePromos') }</span> }
            />
          </div>
          { /* <div className="form__title">{ t('accountPersonalData.bankingDetails') }</div>
          <div className="form__inputs">
            <div className="form__side-container">
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.holder') }:</label>
                <input
                  defaultValue={ owner }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem"
                  type="text"
                  name="owner"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.bankName') }:</label>
                <input
                  defaultValue={ bankName }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem--larger"
                  type="text"
                  name="bankName"
                />
              </div>
            </div>
            <div className="form__side-container">
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.iban') }:</label>
                <input
                  defaultValue={ iban }
                  onChange={ this.onChangeValue }
                  className=
                    "form__label-input-container__elem form__label-input-container__elem--largest"
                  type="text"
                  name="iban"
                />
              </div>
              <div className="form__label-input-container">
                <label>{ t('accountPersonalData.bic') }:</label>
                <input
                  defaultValue={ bicswift }
                  onChange={ this.onChangeValue }
                  className="form__label-input-container__elem form__label-input-container__elem--small"
                  type="text"
                  name="bicswift"
                />
              </div>
            </div>
          </div> */ }
        </div>
        <div className="form__side-container">
          {
            !save ?
              <span>To change your data update the relevant field, enter your Current Password and press Save</span>
              :
              <span>Enter your Current Password to Save changes</span>
          }
        </div>
        <div className="form__submit">
          <Button className="btn--cta" text={ 'Save' } type="submit" disabled={ !save } />
        </div>
      </form>
    );
  }
}

PersonalData.propTypes = {
  t: PropTypes.func,
  customer: PropTypes.object,
  saveCustomer: PropTypes.func,
  getCustomer: PropTypes.func,
  validatePassword: PropTypes.func,
  countries: PropTypes.array,
  passwordValidation: PropTypes.object,
  passwordStrength: PropTypes.object,
  success: PropTypes.bool
};

const mapState = state => ({
  customer: state.auth.customer,
  countries: state.odds.countries,
  passwordValidation: state.content.passwordValidation,
  passwordStrength: state.content.passwordStrength,
  success: state.account.success
});

const mapDispatch = dispatch => ({
  saveCustomer: (payload) => dispatch.account.saveCustomer(payload),
  getCustomer: () => dispatch.auth.getCustomer(),
  validatePassword: (obj) => dispatch.content.validatePassword(obj)
});

export default withRouter(connect(mapState, mapDispatch)(withTranslation('common')(PersonalData)));
